import { render, staticRenderFns } from "./WorkerQuerylogsDashboard.vue?vue&type=template&id=7faf3d0b&"
import script from "./WorkerQuerylogsDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkerQuerylogsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports